<script>
import { fandomBasicMixin } from "src/modules/fandom_mixins_module.js";
import { hfarmCorporateTileMixin } from "../../modules/hfarm_corporate_mixins_module.js";
import { Youtube } from "src/modules/youtube_module.js";
import { mqLess } from 'src/modules/viewport_module';
import { get } from 'lodash';
import Intersect from 'vue-intersect';
import TextModal from "text-modal";

export default {
  mixins: [fandomBasicMixin, hfarmCorporateTileMixin],
  components: { 
    Intersect, 
    TextModal
  },
  data() {
    return {
      loadVideo: false
    }
  },
  methods: {
    toggleYoutubePopup: Youtube.toggleYoutubePopup,
    clickHandler(e) {
      const link = $(`#tile-${this.contentId}`);
      if (this.getTarget(this.content.url) === "_blank") {
        let tab = window.open();
        tab.location = link.attr('href');
      } else {
        window.location = link.attr('href');
      }
    },
    startVideo(event) {
      if (this.content.background_video && this.toggleVideoCondition(event)) {
        this.loadVideo = true;

        Vue.nextTick(() => { 
          const video = $(this.$refs.video)[0];
          video.play();
        });
      }
    },
    pauseVideo(event) {
      if (this.content.background_video && this.loadVideo && this.toggleVideoCondition(event)) {
        const video = $(this.$refs.video)[0];
        video.pause();
        video.currentTime = 0;
        this.loadVideo = false;
      }
    },
    toggleVideoCondition(event) {
      return (event == 'mouseenter' && !mqLess('sm')) || (event == 'intersect' && mqLess('sm'));
    }
  },
  computed: {
    isYoutubePresent() {
      const mediaType = get(this.content, ["play", "media_type"], false);
      return mediaType === "youtube";
    },
    backgroundVideoUrl() {
      const videoMobile = mqLess('sm') ? get(this.content.background_video_mobile, 'url', null) : null;
      return videoMobile || get(this.content.background_video, 'url', null);
    },
    icon() {
      if (!!this.content.icon && typeof this.content.icon == 'object') {
        return this.content.icon;
      } else {
        return null;
      }
    },
    textIcon() {
      if (!!this.content.icon && typeof this.content.icon == 'string') {
        return this.content.icon;
      } else {
        return null;
      }
    },
    titleClass() {
      let titleClass = this.content.title_class;
      if (!titleClass) {
        titleClass = this.content.isotope_size == 'ultrawidecontent' ? 'h1' : 'h4';
      }
      return titleClass;
    }
  }
};
</script>

<template>
  <intersect @enter="startVideo('intersect')" @leave="pauseVideo('intersect')">
    <div v-easyadmin="easyadminId" :class="[contentType]" class="w-100 position-absolute-center">
      <component
        :is="!content.popup_content ? 'a' : 'text-modal'"
        :href="tileUrl"
        :target="getTarget(content.url)" 
        class="w-100 h-100 deco-none position-absolute-center bg-transition text-white" 
        :class="content.isotope_size"
        :id="`tile-${contentId}`"
        :style="{'cursor': content.url || getContentURL(content) ? 'pointer' : 'default', 'background-color': content.background_color}"
        @mouseenter="startVideo('mouseenter')"
        @mouseleave="pauseVideo('mouseenter')"
        @click.prevent="isYoutubePresent && content.url && content.url.url == '$video' ? toggleYoutubePopup() : clickHandler($event)"
        :content="content.popup_content"
        :opt-container-content="containerContent"
        tile-component
      >
        <div 
          class="bg-cover-center position-absolute-center"
          :class="{'bg': tileUrl !== 'javascript:void(0)'}"
          :style="{'background-image': image, 'background-color': content.background_color}"
        ></div>
        <div v-if="loadVideo && content.background_video" class="position-absolute-center">
          <video
            ref="video"
            loop
            webkit-playsinline
            playsinline
            muted
            class="w-100 h-100 object-fit"
            :id="`${content.name}-video-tile`"
          >
            <source :src="expandUrl(backgroundVideoUrl)" type="video/mp4">
          </video>
        </div>
        <div v-if="content.gradient" class="position-absolute-center linear-gradient-y"></div>
        <div class="position-absolute-center">
          <slot name="tile-header" :tileContent="content">
            <div class="d-flex justify-content-start align-items-center icon-container pt-3 pl-3" v-if="!!content.icon">
              <img :src="icon.url" class="icon" v-if="icon">
              <div class="text-uppercase title-icon p2-4 text-center font-weight-bold p-0">{{textIcon}}</div>
            </div>
          </slot>
          <slot name="tile-body" :tileContent="content">
            <div class="position-absolute-center d-flex flex-column justify-content-end p-3">
              <div class="tile-footer d-flex flex-column justify-content-end mx-0 p-0" :class="textAlign" v-if="!content.hide_title">
                <div v-if="content.category" class="bg-white category position-absolute px-2" :style="textColor">
                  <span>{{content.category}}</span>
                </div>
                <div class="w-100">
                  <h3 class="m-0 title d-block" :class="titleClass" :style="textColor">{{content.title}}</h3>
                </div>
                <div>
                  <div class="font-weight-light secondary-title" :style="textColor" v-if="content.secondary_title">{{content.secondary_title}}</div>
                </div>
              </div>
            </div>
          </slot>
        </div>
      </component>
    </div>
  </intersect>
</template>

<style lang="scss" scoped>

@include media-breakpoint-down(md) {
  .hide-title-description-mobile .secondary-title {
    display: none !important;
  }
}

[tile-component] {

  .icon, .title {
    -webkit-transform: translate3d(0,0,0);
  }

  .title-icon {
    font-size: 1.25rem;
  }

  .secondary-title {
    top: 1rem;
    left: 1rem;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }

  .category {
    top: 1rem;
    left: 1rem;
    mix-blend-mode: screen;

    & > span {
      color: $dark;
    }
  }

  &.widecontent {
    img.icon {
      max-width: 17%;
    }  
  }

  img.icon {
    width: auto;
    height: auto;
    z-index: 1;
    max-width: 34%;

    @include media-breakpoint-down(xs) {
      max-width: 26% !important;
    }
  }

  .tile-footer {
    padding: 1.75rem;
  }

  .video-9by16 {
    width: 100%;
    height: 100%;
    overflow: hidden;

    video,
    iframe {
      height: 56.25%;
      width: 177.78%;
      min-height: 100%;
      min-width: 100%;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }

  .bg {
    transition-duration: 3s;
    transition-timing-function: cubic-bezier(0.23,1,0.32,1);
  }

  .layer {
    background: linear-gradient(transparent, transparent 50%, #000000 100%);
  }

  .object-fit {
    object-fit: cover;
  }

  .linear-gradient-y {
    background: linear-gradient(rgba(0, 0, 0, 0) 40%, rgba(0, 0, 0, 0.3));
  }
}
</style>
